import styled, { keyframes } from 'styled-components'
import { RCWidth } from '../utils'
import { useSelector } from 'react-redux';
import NexImage from '../media/whatIsNex.gif'
import p1 from '../media/p2.png'
import empty from '../media/empty-folder.png'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useEffect, useState } from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from 'react-router-dom';
import ToolsUsageChart from './ToolsUsageChart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';


function Home({ nex, _listn }) {
  const [toolsArr, setToolsArr] = useState([])
  const [sum, setSum] = useState(0)
  const [userCategory, setUserCategory] = useState(null)
  const [topThreeTools, setTopThreeTools] = useState([])
  const [showChart, setShowChart] = useState(false)


  const user = useSelector(state => state.user.user);
  const nx = useSelector(state=> state.nex.nex)

  const navigate = useNavigate();

  const calculateToolPercentages = (analytics) => {
    if (!analytics || !analytics.toolsUsage) return {};
  
    const totalUsage = Object.values(analytics.toolsUsage).reduce((acc, val) => acc + (val || 0), 0);
    return Object.fromEntries(
      Object.entries(analytics.toolsUsage).map(([tool, usage]) => [
        tool,
        usage !== null ? (usage / totalUsage) * 100 : 0
      ])
    );
  };



// useEffect(()=> {
//   _listn()
// }, [])


useEffect(() => {
  if (user?.analytics) {
    const sortedToolPercentages = Object.entries(calculateToolPercentages(user.analytics))
      .sort(([, percentageA], [, percentageB]) => percentageB - percentageA);

    setToolsArr(sortedToolPercentages);
  }
}, [user]);


const category = tool => {
  if(tool === 'keyword-research' || tool === 'competition-research') return 'Researcher'
  if(tool === 'google-serp' || tool === 'bing-serp' || tool === 'top-search-queries' || tool === 'indexed-pages' || tool === 'sitemaps') return 'Explorer'
  if(tool === 'crawlability-test' || tool === 'mobile-support-test' || tool === 'headers-test' || tool === 'speed-test') return 'Tester'
  if(tool === 'link-analysis' || tool === 'keyword-density' || tool === 'extract-meta-tags') return 'Content Creator'
  if(tool === 'high-quality-backlinks' || tool === 'new-backlinks' || tool === 'low-quality-backlinks' || tool === 'top-referrers' || tool === 'page-authority' || tool === 'domain-authority') return 'Connector'
}


// let userCategory = toolsArr.length > 0? category(toolsArr[0][0]) : null

useEffect(()=> {
  let uc = toolsArr.length > 0? category(toolsArr[0][0]) : null
  setUserCategory(uc)
}, [toolsArr, user])



useEffect(()=> {
  if(toolsArr.length !== 0) {
    const getTopThreeTools = (toolsArr) => {
    return toolsArr
      .sort((a, b) => {
        const percentageA = Number(a[1]) || 0; // Convert percentage to number or use 0 if NaN
        const percentageB = Number(b[1]) || 0; // Convert percentage to number or use 0 if NaN
        return percentageB - percentageA; // Sort in descending order
      })
      .slice(0, 3) // Get the top 3 tools
      .map(([tool]) => 
        tool.replaceAll('-', ' ') === 'google search' ? 'google serp' : tool.replaceAll('-', ' ')
      ); // Return only tool names
  };

  const topThreeT = getTopThreeTools(toolsArr)

  setTopThreeTools(topThreeT)
}
}, [user, toolsArr])


const projects = useSelector(state=> state.projects.projects) || [];

const sortedProj = projects ? [...projects].sort((a, b) => a.n - b.n) : null;

const recProj = sortedProj ? sortedProj.slice(-3).reverse() : null;


return (
    <HomeContainer>
      <UpperContainer empty={projects.length === 0? true: false}>
        {projects.length !== 0 && <>
        <div>
        <h3><WorkHistoryIcon /> Recent Projects</h3>
         {recProj.length !== 0 && recProj?.map(p=> {
          if(p.type == 'site-report') return
          return (
            <div className='recP' onClick={()=> navigate(`/projects/${p.type === 'keyword'? 'kp': p.type === 'competition'? 'cp': p.type === 'backlink-profile'? 'bpp': p.type === 'site-report'? 'srp': p.type === 'content-ideas'? 'ci': 'ls'}?=${p.name.toLowerCase()}`)}>
              <h5>{p?.name}</h5>
              <p style={{color: p.type?.toLowerCase() === 'keyword'? 'dodgerblue': p.type?.toLowerCase() === 'competition'? 'purple': p.type?.toLowerCase() === 'content-ideas'? 'var(--cntnt-color)': 'slategray'}}>{p?.type?.replaceAll('-', ' ')} project</p>
            </div>
          )
         })}

         
         </div>

         <div className='imageBox'>
            <img src={p1} />
         </div>
         </>}

         {projects.length === 0 && <div className='empty'>
            <img src={empty}/>
            <p>Oops! Your project folder is empty. 🤔 Start your MarketLab journey by creating your first project and bring this space to life! <span onClick={()=> navigate('/projects')}>Go to projects</span></p>
          </div>}
      </UpperContainer>

      <LowerContainer userCategory={false} sum={Number(sum)} isNex={false} style={{marginBottom: '60px'}}>

        
        <div className='left_updates' style={{height: '300px', backgroundColor: '#191c2c'}}>
          
          <h3 style={{color: 'white'}}><SettingsIcon /> Updates and Announcements</h3>
          <p style={{fontFamily: 'Quicksand', color: 'dodgerblue'}}>MarketLab v5 Update: System Enhancements and New Features!</p>
          
          <div className='vid_container'>
          <video controls width="100%">
            <source src='https://firebasestorage.googleapis.com/v0/b/market-lab-2ed93.appspot.com/o/media%2Fml_v5.mp4?alt=media&token=aa7e66d2-6485-47ba-bc26-013553e2b090' type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          </div>
        </div>
        
        <div className='right' style={{ height: '300px', backgroundColor: '#191c2c' }}>
          {topThreeTools.length !== 0 && (
            <h3 style={{ marginBottom: '20px', color: 'white' }}>
              <AutoFixHighIcon /> Quick Tools Access
            </h3>
          )}
          {topThreeTools.length !== 0 ? (
            topThreeTools.map(t => {
              return (
                <p
                  key={t} // Add a key prop to the p element
                  className='tool'
                  onClick={() =>
                    navigate(
                      t.toLowerCase() === 'google search'
                        ? 'google-serp'
                        : t.toLowerCase() === 'bing search'
                        ? 'bing-serp'
                        : t.toLowerCase().replaceAll(' ', '-')
                    )
                  }
                >
                  {t}
                </p>
              );
            })
          ) : (
            <p style={{color: 'white', fontFamily: 'Quicksand', display: 'flex', alignItems: 'center', gap: '5px'}}><InfoIcon /> Try using the tools to see your usage stats.</p>
          )}
        </div>

      </LowerContainer>

      <LowerContainer userCategory={userCategory} sum={Number(sum)} isNex={true}>

        
        <div className='left' style={{width: '60%'}}>
          
          {!showChart && <>
          {userCategory? <h3 style={{fontFamily: 'none', color: 'white'}}>You are a <span>{userCategory}</span> {userCategory && <AssessmentIcon onClick={()=> setShowChart(true)}/>} </h3>: <p className='empty_title'><AutoAwesomeIcon /> Explore more tools to reveal your unique skills!</p>}
          <p style={{fontFamily: 'Quicksand', color: 'white'}}>Tools Usage:</p>
          <div>
          {/* {toolsArr.map(([tool, percentage]) => (
                        <div key={tool}>
                            <p>{tool.replaceAll('-', ' ') === 'google search'? 'google serp': tool.replaceAll('-', ' ')} </p>
                            {isNaN(Number(percentage))? <span>0.00%</span> : <span>{percentage.toFixed(2)}%</span>}
                        </div>
          ))} */}
                {toolsArr
          .sort((a, b) => {
              const percentageA = Number(a[1]) || 0; // Convert percentage to number or use 0 if NaN
              const percentageB = Number(b[1]) || 0; // Convert percentage to number or use 0 if NaN
              return percentageB - percentageA; // Sort in descending order
          })
          .map(([tool, percentage]) => (
              <div key={tool}>
                  <p>
                      {tool.replaceAll('-', ' ') === 'google search'
                          ? 'google serp'
                          : tool.replaceAll('-', ' ')}
                  </p>
                  {isNaN(Number(percentage)) ? (
                      <span>0.00%</span>
                  ) : (
                      <span>{percentage.toFixed(2)}%</span>
                  )}
              </div>
          ))}
          </div>
          </>}

          {showChart && <>
          <h3 style={{color: 'white'}}>Tools Usage Chart {userCategory && <TextSnippetIcon onClick={()=> setShowChart(false)}/>}</h3>
          <div style={{width: '100%', height: '100%', overflow: 'hidden'}}>
            <ToolsUsageChart toolsArr={toolsArr} />
          </div>
          </>}
        </div>
        
        <div className='right' style={{width: '40%'}}>
          <h3><span style={{color: '#de2699'}}>Nexilum</span> Units</h3>
          {!user.prem && <p>You currently have <span style={{color: '#de2699'}}>{nx}</span> units</p>}
          {user.prem && <p>You currently have <span style={{color: '#de2699'}}>infinite Nexilum</span> units</p>}
          <img src={NexImage} />
        </div>
      </LowerContainer>
      <div style={{marginBlock: '60px'}} />
    </HomeContainer>
  )
}

export default Home


const HomeContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
    width: ${RCWidth};
    align-items: center;
    z-index: 1000;
    height: 100vh !important;
    overflow-y: auto !important;
`


const userCategoryColors = {
  'Researcher': 'var(--res-color)',
  'Explorer': 'orange',
  'Tester': 'var(--tst-color)',
  'Content Creator': 'var(--cntnt-color)',
  'Connector': 'var(--bl-color)'
};

const UpperContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 98%;
  height: 300px;
  border-radius: 3px;
  /* background-color: #f5f5f5; */
  margin-top: 25px;
  /* background: ${props=> !props.empty? 'linear-gradient(90deg, #f5f5f5 60%, lightyellow)': '#f5f5f5'}; */
  /* background: ${props=> !props.empty? 'linear-gradient(100deg, #191c2c 50%, lightyellow)': '#191c2c'}; */
  background-color: #191c2c;

  > div {
    display: flex;
    flex-direction: column;
    width: 60%;
  }

    > div > h3 {
      /* font-family: 'Roboto Flex'; */
      font-weight: 300;
      font-size: 32px;
      margin: 10px 0 25px 10px;
      font-family: 'Quicksand';
      color: white;
    }

    > div > .recP {
      display: flex;
      flex-direction: row;
      margin: 10px 0 25px 10px;
      font-weight: 300;
      cursor: pointer;
      transition: background-color 0.3s ease-in-out;
      padding-inline: 5px;
      border-radius: 3px;

      &:hover {
        background-color: lightgray;
        > h5 {
          color: black;
        }
      }

      > h5 {
        /* font-family: 'Crimson Text'; */
        font-weight: 300;
        font-size: large;
        color: white;
        font-family: 'Quicksand';
      }

      > p {
        /* font-family: 'Crimson Text'; */
        margin-left: auto;
        text-transform: capitalize;
        margin-right: 20px;
        width: 200px;
        font-family: 'Quicksand';
      }
    }


    > .imageBox {
      display: flex;
      justify-content: center;
      align-items: center;
      
      > img {
      object-fit: contain;
      width: 160px;
    }
  }


  > .empty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
      object-fit: contain;
      width: 200px;
      filter: grayscale(1);
      opacity: 0.5;
    }

    > p {
      font-family: 'Crimson Text';
      color: #9f9f9f;
      display: flex;
      align-items: center;
      gap: 7px;

      > span {
        cursor: pointer;
        color: dodgerblue;
        transition: color 0.2s ease-in-out;

        &:hover {
          color: gray;
        }
      }
    }
  }
`


const TextEffect = keyframes`
  0% {
    color: blue;
  }

  50% {
    color: cornflowerblue;
  }

  100% {
    color: blue;
  }
`


const LowerContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 98%;
  height: 260px;
  gap: 30px;
  margin-bottom: 30px;

  > div {
    display: flex;
    flex-direction: column;
    width: 80%;
    height: 100%;
    background-color: #f5f5f5;
    border-radius: 3px;
    padding: 10px;

    > h3 {
      font-family: 'Crimson Text';
      font-weight: 300;
      font-size: 32px;

      > span {
        color: ${props=> props.userCategory === 'Researcher'? 'var(--res-color)': props.userCategory === 'Explorer'? 'orange': props.userCategory === 'Tester'? 'var(--tst-color)': props.userCategory === 'Content Creator'? 'var(--cntnt-color)': props.userCategory === 'Connector'? 'var(--bl-color)': ''};
      }
    }

    > p {
      font-family: 'Crimson Text';
      margin-block: 15px;
      color: gray;
    }

    > img {
      object-fit: contain;
      width: 160px;
    }

    > div {
      height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      margin-top: 15px;

      > div {
        display: flex;
        margin-bottom: 12px;
        text-transform: capitalize;
        font-family: 'Quicksand';

        > p {
          font-family: 'Quicksand';
          color: white;
        }

        > span {
          margin-left: auto;
          margin-right: 20px;
          font-family: 'Quicksand';
          color: black;
        }
      }
    }
  }

  > .left {
    /* background: linear-gradient(
    60deg,
    #f5f5f5 65%,
    ${({ userCategory, sum }) =>  userCategoryColors[userCategory] || '#f5f5f5'} ); */
    background: linear-gradient(
    90deg,
    #191c2c 55%,
    ${({ userCategory, sum }) =>  userCategoryColors[userCategory] || '#191c2c'} );
    height: 260px;


    > h3 {
      font-family: 'Quicksand' !important;
      display: flex;
      align-items: center;
      gap: 5px;
      width: 100%;

      > .MuiSvgIcon-root {
        cursor: pointer;
        transition: color 0.3s ease-in-out;
        color: white;
        margin-left: auto;
        font-size: 37px;

        &:hover {
          color: dodgerblue;
        }
      }
    }

    > .empty_title {
      font-weight: 300;
      font-size: large;
      color: blue;
      display: flex;
      align-items: center;
      gap: 10px;


      animation: ${TextEffect} 2s ease-in-out infinite;
    }

    &::-webkit-scrollbar {
    width: 12px; /* Width of the scrollbar */
  }

  &::-webkit-scrollbar-track {
    background: linear-gradient(45deg, #f9d4b4, #ffecd2); /* Track background */
    border-radius: 10px; /* Rounded corners */
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(45deg, #ff6b6b, #f06595); /* Thumb background */
    border-radius: 10px; /* Rounded corners */
    border: 3px solid transparent; /* Space between thumb and track */
    background-clip: padding-box; /* Prevent overlap */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555; /* Change color on hover */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); /* Shadow on hover */
  }

  /* Custom Scrollbar Styles for Firefox */
  scrollbar-width: thin; /* Use thin scrollbar */
  scrollbar-color: slategray lightgray; /* Thumb color and track color */
  }



  > .left_updates {
    height: 260px;


    > .vid_container {
      border-radius: 4px;
      width: 80%;
      height: 70%;
      overflow: hidden !important;

      > video {
        height: 100%;
      }
    }

    > h3 {
      font-family: 'Quicksand' !important;
      display: flex;
      align-items: center;
      gap: 5px;
    }

    > .empty_title {
      font-weight: 300;
      font-size: large;
      color: blue;
      display: flex;
      align-items: center;
      gap: 10px;


      animation: ${TextEffect} 2s ease-in-out infinite;
    }

    &::-webkit-scrollbar {
    width: 12px; /* Width of the scrollbar */
  }

  &::-webkit-scrollbar-track {
    background: linear-gradient(45deg, #f9d4b4, #ffecd2); /* Track background */
    border-radius: 10px; /* Rounded corners */
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(45deg, #ff6b6b, #f06595); /* Thumb background */
    border-radius: 10px; /* Rounded corners */
    border: 3px solid transparent; /* Space between thumb and track */
    background-clip: padding-box; /* Prevent overlap */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555; /* Change color on hover */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); /* Shadow on hover */
  }

  /* Custom Scrollbar Styles for Firefox */
  scrollbar-width: thin; /* Use thin scrollbar */
  scrollbar-color: slategray lightgray; /* Thumb color and track color */
  }


  > .right {
    background: ${props=> props.isNex? 'linear-gradient(60deg, #f5f5f5 60%, #e46db6)': ''};
    height: 260px;

    > .tool {
      background-color: #c2e1ff;
      color: black;
      cursor: pointer;
      padding: 3px;
      border-radius: 5px;
      transition: background-color 0.3s ease-in-out;
      width: fit-content;
      text-transform: capitalize;
      font-family: 'Quicksand';

      &:hover {
        background-color: transparent;
        color: #c2e1ff;
      }
    }
  }
`